<template>
    <div class="flex items-center">
        <slot></slot>
    </div>
</template>
